import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IBrand } from '../../../components/models/models'
import { IBrandNotice, IBrandNoticeRequest } from '../models/models'

export class ListBrandNoticeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/brand/listBrandNotice',
      requesterInfo,
    })
  }

  public async getBrandNotice(): Promise<IBrandNotice[]> {
    return await this.getAsync<IBrandNotice[]>()
  }
}
